import React from 'react';

const SaveTimeIcon = () => (
  <svg width={44} height={44} viewBox="0 0 44 44" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.266 10.71h-2.534v12.56h12.361v-2.53h-9.827V10.71"
      fill="#B20094"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.465 22c0 10.74-8.732 19.47-19.465 19.47-10.735 0-19.466-8.73-19.466-19.47C2.534 11.27 11.265 2.54 22 2.54c10.733 0 19.465 8.73 19.465 19.46zM22 0C9.869 0 0 9.87 0 22s9.869 22 22 22 22-9.87 22-22S34.131 0 22 0z"
      fill="#B20094"
    />
  </svg>
);

export default SaveTimeIcon;
